import { Ref, onMounted } from 'vue'
import type AmsSlider from './AmsSlider.vue'
import debounce from 'lodash-es/debounce'
import { useIsMounted } from '../../composables/useIsMounted'

export enum SlideDirection {
    Left = 'left',
    Right = 'right',
    NoChange = 'no-change',
}

export const useSliderDirection = (amsSliderRef: Ref<InstanceType<typeof AmsSlider> | undefined>) => {
    let initialScrollLeft = 0
    const isMounted = useIsMounted()

    const getScrollableElement = () => {
        if (!isMounted.value) {
            throw new Error('useSliderDirection: used before mount')
        }
        const el = amsSliderRef.value?.scrollableElement
        if (!el) {
            throw new Error('useSliderDirection: no scrollable element')
        }
        return el
    }

    const initialScrollUpdateHandler = debounce(() => {
        initialScrollLeft = getScrollableElement().scrollLeft
    }, 400)

    const getSlideDirection = () => {
        const newScrollLeft = getScrollableElement().scrollLeft
        if (newScrollLeft === initialScrollLeft) {
            return SlideDirection.NoChange
        }
        if (initialScrollLeft > newScrollLeft) {
            return SlideDirection.Left
        }
        return SlideDirection.Right
    }

    onMounted(() => {
        getScrollableElement().addEventListener('scroll', initialScrollUpdateHandler)
    })

    return {
        getSlideDirection,
    }
}
